import React from 'react';

const OAuthDefaultContainer = () => <></>;

export default OAuthDefaultContainer;
